import { matchTrackerApi, metricsServerApi } from '../../modules/servers/api'
import { RootState } from '../../store'
import { upsertOneEvent } from '../events'
import { RawDrillEventData } from '../events/types'
import { RawDrillData } from './types'

export const drillsApiMetricsServer = metricsServerApi.injectEndpoints({
  endpoints: (builder) => ({
    // Create Drill - now allows properties to be sent
    createDrill: builder.mutation<
      RawDrillEventData,
      Omit<
        RawDrillEventData,
        | 'id'
        | 'createdAt'
        | 'updatedAt'
        | 'ignore'
        | 'startTime'
        | 'endTime'
        | 'tags'
        | 'outcomes'
        | 'data'
      > & {
        data: Omit<RawDrillData, 'id' | 'eventID'>
        properties?: {
          // Optional properties field
          notes?: string
          highlight?: boolean
          [key: string]: any
        }
      }
    >({
      query: (data) => ({
        url: `api/v2/drills`,
        method: 'POST',
        body: data,
        withCredentials: true
      }),
      onQueryStarted: async (data, { dispatch, queryFulfilled }) => {
        try {
          const response = await queryFulfilled
          // Add drill to events
          const drillData = response.data
          dispatch(upsertOneEvent(drillData))
          // The breakdown query lives on matchTrackerApi, so its tag must be
          // invalidated across slices — invalidatesTags here would silently no-op
          dispatch(
            matchTrackerApi.util.invalidateTags([
              { type: 'drillPlayerBreakdown', id: drillData.id }
            ])
          )
        } catch (error) {
          console.error('Error creating drill:', error)
        }
      }
    }),

    // Update Drill - already supports properties via Partial
    updateDrill: builder.mutation<RawDrillEventData, RawDrillEventData>({
      query: (data) => ({
        url: `api/v2/drills/${data.id}`,
        method: 'PUT',
        body: data,
        withCredentials: true
      }),
      onQueryStarted: async (data, { dispatch, queryFulfilled, getState }) => {
        const currentEvent = (getState() as RootState).events.entities[data.id]
        dispatch(upsertOneEvent(data))
        try {
          const response = await queryFulfilled
          // Add drill to events
          const drillData = response.data

          dispatch(upsertOneEvent(drillData))
          // The breakdown query lives on matchTrackerApi, so its tag must be
          // invalidated across slices — invalidatesTags here would silently no-op
          dispatch(
            matchTrackerApi.util.invalidateTags([
              { type: 'drillPlayerBreakdown', id: drillData.id }
            ])
          )
        } catch (error) {
          console.error('Error updating drill:', error)
          // Revert optimistic update if the API call fails
          if (currentEvent) {
            dispatch(upsertOneEvent(currentEvent))
          }
        }
      }
    })
  })
})

export const { useCreateDrillMutation, useUpdateDrillMutation } =
  drillsApiMetricsServer
